module.exports = __webpack_public_path__ + "static/Macbook-18b87b85b257c10e686d1dfb743da002.svg";